module.exports = __webpack_public_path__ + "static/media/Snack – 1.d8ae9c5d.jpg";